export const PROFESSIONAL = {
  url: 'https://www.coches.net/registro-profesionales/',
  proUrl: 'https://pro.coches.net/'
}

export const SOCIAL_MEDIA_IDS = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  TIKTOK: 'tiktok',
  LINKEDIN: 'linkedin'
}

export const social = [
  {
    url: 'https://www.facebook.com/Motos.net',
    text: SOCIAL_MEDIA_IDS.FACEBOOK
  },
  {
    url: 'https://twitter.com/motosnet',
    text: SOCIAL_MEDIA_IDS.TWITTER
  },
  {
    url: 'https://www.instagram.com/motosnet/',
    text: SOCIAL_MEDIA_IDS.INSTAGRAM
  },
  {
    url: 'https://www.youtube.com/user/canalmotosnet',
    text: SOCIAL_MEDIA_IDS.YOUTUBE
  },
  {
    url: 'https://www.tiktok.com/@motos.net',
    text: SOCIAL_MEDIA_IDS.TIKTOK
  },
  {
    url: 'https://es.linkedin.com/company/coches-net',
    text: SOCIAL_MEDIA_IDS.LINKEDIN
  }
]

export const stores = {
  itunes: {
    url: 'https://itunes.apple.com/es/app/motos.net/id889850512?mt=8',
    text: 'iTunes'
  },
  gplay: {
    url: 'https://play.google.com/store/apps/details?id=motos.net',
    text: 'Google Play'
  }
}
